import { useId, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import type { FaqItem } from '../../data/faq';
import { ease } from '../../core/format/motion';

/** Veelgestelde vragen als accordeon; de eerste staat open. Zonder vragen niets. */
export function Faq({
  items,
  title
}: {
  items: FaqItem[];
  title: string;
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduce = useReducedMotion();
  const baseId = useId();
  if (items.length === 0) return null;
  return <div className="grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-8623" data-mp="nistozbj9jxe">
      <div className="lg:col-span-4" data-id="element-8624" data-mp="niap9fepvzee">
        <h2 className="font-display text-4xl font-light leading-[1.08] text-ink" data-id="element-8625" data-mp="ijpzk9x3cy47">{title}</h2>
      </div>
      <ul className="border-t border-line lg:col-span-8" data-id="element-8626" data-mp="2pa5ubc6gx5nn">
        {items.map((item, i) => {
        const isOpen = openIndex === i;
        const answerId = `${baseId}-${i}`;
        return <li key={item.question} className="border-b border-line" data-id="element-8627" data-mp="p4vf13lngqtt" data-mpi={i}>
              <h3 data-id="element-8628" data-mp="p2io40xwz64m">
                <button type="button" aria-expanded={isOpen} aria-controls={answerId} onClick={() => setOpenIndex(isOpen ? null : i)} className="group flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-8629" data-mp="t66w2kqgk3qe">
                  <span className="font-display text-xl font-light text-ink transition-colors duration-150 ease-soft group-hover:text-clay" data-id="element-8630" data-mp="17vml9wacc13z">{item.question}</span>
                  <span className="shrink-0 text-muted transition-colors duration-150 ease-soft group-hover:text-ink" aria-hidden="true" data-id="element-8631" data-mp="1cw0u3gjrnf32">
                    {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-8632" data-mp="1lttako184ss1" /> : <PlusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-8633" data-mp="1lsi5mkw1lezc" />}
                  </span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-8634" data-mp="3nlfts3evjjdy">
                {isOpen && <motion.div id={answerId} initial={reduce ? {
              opacity: 0
            } : {
              height: 0,
              opacity: 0
            }} animate={reduce ? {
              opacity: 1
            } : {
              height: 'auto',
              opacity: 1
            }} exit={reduce ? {
              opacity: 0
            } : {
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease
            }} className="overflow-hidden" data-id="element-8635" data-mp="urh98mj72t1b">
                    <p className="max-w-2xl pb-6 text-[16px] leading-relaxed text-muted" data-id="element-8636" data-mp="1dpbqtoye2cvb">{item.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </div>;
}